import React, { useState, useEffect } from "react";
import styles from "./BusinessDetails.module.scss";
import NavBar from "../../components/navbar/NavBar";
import { useParams, useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import StatusView from "../StatusView/StatusView";
import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import BusinessConfig from "./businessConfig/BusinessConfig";
import { useDispatch, useSelector } from "react-redux";
import { openModalAndSetContent } from "../../redux/actions/modal/modalActions";
import BusinessSubTab from "./BusinessSubTab";
import { BusinessDetailApiTypes } from "../../types/UserTableTypes";
import axios from "axios";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import PaginationTable from "../paginatedTable/pagination-table";
import { ColumnMeta, BusinessMeta } from "../../types/BusinessModule";
import { Box } from "@mui/material";
import TableHeader from "../TableHeader/TableHeader";
import DisableBusiness from "./disableBusiness/DisableBusiness";
import { numberWithCommas } from "../../util/formatNumber";
import { formatTime } from "../../util/timeUtils";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function BusinessDetails({ }: {}) {
	const history = useHistory();
	const dispatch = useDispatch();
	const [details, setDetails] = useState<any>();

	const [metaDetails, setMetaDetails] = useState<any>();

	const [tableRow, setTableRow] = useState<any[]>();
	const [contentAction, setContentAction] = useState<any>({});
	const [bearer, setBearer] = useState(false);

	//PAGINATION
	const [value, setValue] = useState("");
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(100);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	const { id } = useParams<any>();

	const getMetaData = async () => {
		try {
			const { data } = await axios.get(`/v1/business/${id}/meta`);
			setMetaDetails(data);
		} catch (err: any) {
			dispatch(
				openToastAndSetContent({
					toastContent:
						err.response?.data?.message ||
						err?.data?.message ||
						err?.message ||
						err,
					toastType: "error",
				})
			);
		}
	};

	const auth = useSelector((state) => state?.mePayReducer?.me?.user);


	useEffect(() => {
		getMetaData();
	}, [bearer, value, pageNumber, rowsPerPage]);

	const dataBusinesses = () => {
		const tempArr: BusinessMeta[] = [];
		metaDetails?.meta
			?.slice(0)
			.reverse()
			.forEach((business: any, index: number) => {
				return tempArr.push({
					merchantaccountmetaid: business?.merchantaccountmetaid,
					name: business?.name,
					value: business?.value,
					createdat: formatTime(business?.createdat),
					other: business?.other || "N/A",
				});
			});
		return tempArr;
	};
	//Add meta data
	useEffect(() => {
		axios
			.get<any>(`/v1/business/${id}`)
			.then((res) => {
				setDetails(res.data);
				setBearer(false);
			})
			.catch((err) => {
				dispatch(
					openToastAndSetContent({
						toastContent:
							err.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				);
			});

		getMetaData();
	}, [id, bearer]);

	const editConfigHandler = () => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div className={styles.modalDiv}>
						<BusinessConfig
							config={details?.config}
							id={details?.business.merchantaccountid}
							setBearer={setBearer}
						/>
					</div>
				),
			})
		);
	};

	const modifyBusinessHandler = () => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div className={styles.modalDiv}>
						<DisableBusiness
							id={details?.business.merchantaccountid}
							setBearer={setBearer}
						/>
					</div>
				),
			})
		);
	};

	const CustomerInfo = ({ title, details }: any) => {
		return (
			<div className={styles.customerInfo}>
				<div className={styles.detailsValue}>{title}</div>
				<div className={styles.detailsKey}>{details}</div>
			</div>
		);
	};

	const handleBackToBusinesses = () => {
		history.push("/businesses");
	};

	useEffect(() => {
		setTableRow(dataBusinesses());
	}, [metaDetails?.meta, details?.business?.status]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name={details?.business?.tradingname} />
			{details?.business && (
				<div className={styles.containerBusiness}>
					<div className={styles.transactionsHeader}>
						<div
							style={{
								color: "#211F01",
								display: "inline",
								cursor: "pointer",
								fontWeight: "800px",
							}}
						>
							<span className={styles.back} onClick={handleBackToBusinesses}>
								<ArrowLeftIcon /> Back to businesses
							</span>
						</div>

						{auth && auth?.userRole.userRoleName != "PARTNER" && (
							<div>
								<button
									onClick={() => editConfigHandler()}
									className={styles.addButton}
								>
									Config Business
								</button>
								{details?.business?.status &&
									details?.business?.status === "active" ? (
									<button
										onClick={() => modifyBusinessHandler()}
										className={styles.disableButton}
										style={{ backgroundColor: "#FFD2D2", color: "#FF7D7A" }}
									>
										Disable Business
									</button>
								) : (
									<button
										onClick={() => modifyBusinessHandler()}
										className={styles.disableButton}
										style={{ backgroundColor: "#27AD60" }}
									>
										Activate Business
									</button>
								)}
							</div>
						)}
					</div>

					<div
						className={styles.businessContent}
						style={{ marginBottom: "30px" }}
					>
						<div style={{ display: "flex" }} className={styles.businessName}>
							<div>
								<span className={styles.tradingName}>
									{details?.business?.tradingname}
									<StatusView
										status={
											details?.business?.status === "active"
												? "Active"
												: "InActive"
										}
										orange="InActive"
										green="Active"
										style={{
											marginLeft: "10px",
										}}
									/>

									{details?.business?.islive === true ? (
										<p
											style={{
												backgroundColor: "#D6FFE7",
												color: "#066A2D",
												fontWeight: "500",
												fontSize: "0.6em",
												fontFamily: "Avenir",
												paddingLeft: "15px",
												paddingRight: "15px",
												marginLeft: "20px",
												borderRadius: "30px",
											}}
										>
											Live
										</p>
									) : (
										<p
											style={{
												backgroundColor: "#FFD2D2",
												color: "#FF7D7A",
												fontWeight: "500",
												fontSize: "0.6em",
												fontFamily: "Avenir",
												paddingLeft: "15px",
												paddingRight: "15px",
												marginLeft: "20px",
												borderRadius: "30px",
											}}
										>
											Test
										</p>
									)}
								</span>

								<span className={styles.merchantID}>
									Merchant Code:{details?.business?.merchantcode}
								</span>
							</div>
						</div>

						<div className={styles.merchantDetails}>
							<CustomerInfo
								title={"Trading Name"}
								details={details?.business?.tradingname}
							/>
							<CustomerInfo
								title={"Business Email"}
								details={details?.business?.businessemail}
							/>
							<CustomerInfo
								title={"Phone Number"}
								details={details?.business?.businessphone}
							/>
							<CustomerInfo
								title={"Account Type"}
								details={details?.business?.merchantaccounttype}
							/>

						</div>

						<div className={styles.merchantDetails}>
							<CustomerInfo
								title={"Business Category"}
								details={details?.business?.bizindustrycategory}
							/>
							<CustomerInfo
								title={"MCC Code"}
								details={details?.business?.mcc}
							/>
							<CustomerInfo
								title={"Country"}
								details={details?.business?.country}
							/>


						</div>
						<div className={styles.merchantDetails}>
							<CustomerInfo
								title={"Sign Up Date"}
								details={formatTime(details?.business?.createdat)}
							/>
							<CustomerInfo
								title={"Time Approved"}
								details={
									details?.business?.timeapproved === null
										? "N/A"
										: formatTime(details?.business?.timeapproved)
								}
							/>
							<CustomerInfo
								title={"Approval Reason"}
								details={details?.business?.approvereason ?? "N/A"}
							/>
						</div>
					</div>

					{details?.balances.length > 0 && (
						<div
							className={styles.businessContent}
							style={{ marginBottom: "30px" }}
						>
							<div className={styles.businessName}>
								<span className={styles.more}>Merchant Balances</span>
							</div>
							{details?.balances.map((bal: any, i: number) => (
								<div key={i} className={styles.merchantDetails}>
									<CustomerInfo
										title={"Available Balance"}
										details={
											<div style={{ fontWeight: "600", fontSize: "1.4em" }}>
												{`${bal?.currency} ${numberWithCommas(
													bal?.availablebalance
												)}`}
											</div>
										}
									/>
									<CustomerInfo
										title={"Ledger Balance"}
										details={
											<div style={{ fontWeight: "600", fontSize: "1.4em" }}>
												{`${bal?.currency} ${numberWithCommas(
													bal?.ledgerbalance
												)}`}
											</div>
										}
									/>
									<CustomerInfo
										title={"Reserve Balance"}
										details={
											<div style={{ fontWeight: "600", fontSize: "1.4em" }}>
												{`${bal?.currency} ${numberWithCommas(
													bal?.reservebalance
												)}`}
											</div>
										}
									/>
								</div>
							))}
						</div>
					)}

					{details?.address?.merchantaccountid && (
						<div
							className={styles.businessContent}
							style={{ marginBottom: "30px" }}
						>
							<div className={styles.businessName}>
								<span className={styles.more}>More Information</span>
							</div>
							<div className={styles.merchantDetails}>
								<CustomerInfo
									title={"Merchant Address ID"}
									details={details?.address?.merchantaccountaddressid}
								/>
								<CustomerInfo
									title={"Address Type"}
									details={details?.address?.addresstype}
								/>
								<CustomerInfo
									title={"Address Line"}
									details={details?.address?.addressline1}
								/>
								<CustomerInfo
									title={"State"}
									details={details?.address?.state}
								/>
								<CustomerInfo
									title={"Country"}
									details={details?.address?.country}
								/>
							</div>

							<div className={styles.merchantDetails}>
								<CustomerInfo title={"City"} details={details?.address?.city} />
								<CustomerInfo
									title={"Bank Code"}
									details={details?.settlementAccount[0]?.bankcode}
								/>
								<CustomerInfo
									title={"Account Name"}
									details={details?.settlementAccount[0]?.accountname}
								/>
								<CustomerInfo
									title={"Account Number"}
									details={details?.settlementAccount[0]?.accountnumber}
								/>
								<CustomerInfo
									title={"Default"}
									details={
										details?.settlementAccount[0]?.isdefault ? "Yes" : "No"
									}
								/>
							</div>
						</div>
					)}

					<Box mt={4}>
						<div className={styles.m1}>
							<TableHeader
								pageName="Meta Data"
								data={metaDetails}
								dataLength={metaDetails?.length}
								value={value}
								setValue={setValue}
								exporting={false}
								filtering={false}
								// dropdown={dropdown}
								// setDropdown={setDropdown}
								placeHolder="Search"
							// handleClick={handleDownload}
							/>

							<PaginationTable
								data={tableRow ? tableRow : []}
								columns={ColumnMeta ? ColumnMeta : []}
								emptyPlaceHolder={
									metaDetails?.length == 0 ? "No record found" : "Loading..."
								}
								value={value}
								total={metaDetails?.length}
								totalPage={0}
								pageNumber={pageNumber}
								setPageNumber={setPageNumber}
								nextPage={nextPage}
								setNextPage={setNextPage}
								previousPage={previousPage}
								setPreviousPage={setPreviousPage}
								rowsPerPage={rowsPerPage}
								setRowsPerPage={setRowsPerPage}
								clickAction={true}
								setContentAction={setContentAction}
								recent={false}
								setBearer={setBearer}
							/>
						</div>
					</Box>

					{/* <div className={styles.detailBox}>
        <div className={styles.detailBoxCorner}>
          <h3 className={styles.detailh3}>OVERVIEW</h3>
        </div>

        <Divider style={{ color: "#CECECD" }} />
        <div className={styles.box}>
          <div className={styles.singleBox}>
            <p>Available Balance</p>
            <h3>{details?.balances[0]?.availablebalance || 0}</h3>
          </div>
          <div className={styles.singleBox}>
            <p>Ledger Balance</p>
            <h3>{details?.balances[0]?.ledgerbalance || 0}</h3>
          </div>
          <div className={styles.singleBox}>
            <p>Reserve Balance</p>
            <h3>{details?.balances[0]?.reservebalance || 0}</h3>
          </div>
        </div>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Merchant ID</div>
                <div className={styles.detailsKey}>
                  {details?.business?.merchantaccountid}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Merchant Code</div>
                <div className={styles.detailsKey}>
                  {details?.business?.merchantcode}{" "}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Sign Up Date</div>
                <div className={styles.detailsKey}>
                  {" "}
                  {details?.business?.createdat}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Status</div>
                <div className={styles.detailsKey}>
                  <StatusView
                    status={
                      details?.business?.status === "1" ? "Active" : "InActive"
                    }
                    orange="InActive"
                    green="Active"
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Email Address</div>
                <div className={styles.detailsKey}>
                  {details?.business?.businessemail}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Mobile Phone</div>
                <div className={styles.detailsKey}>
                  {details?.business?.businessphone}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Account Type</div>
                <div className={styles.detailsKey}>
                  {details?.business?.merchantaccounttype}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Country</div>
                <div className={styles.detailsKey}>
                  {details?.business?.country}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Address</div>
                <div className={styles.detailsKey}>
                  {details?.address
                    ? details?.address?.addressline1
                    : "Not provider"}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <div className={styles.customerInfo}>
                <div className={styles.detailsValue}>Mcc</div>
                <div className={styles.detailsKey}>
                  {" "}
                  {details?.business?.mcc || "Not Provided"}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div> */}
					{/* <BusinessSubTab id={id} /> */}
				</div>
			)}
		</div>
	);
}

export default BusinessDetails;
